import {Autoplay, Navigation, Swiper, Pagination} from "swiper";
import {breakpointDown, breakpointUp} from "../utils/breakpoints";
import {playLottie} from "../helpers/lottie";
import {loadBlockLazyImages, loadElementLazyImage} from "../helpers/lazy-load";


$('.js-phone-slider').each(function (i, el) {
  let breakpointUpVal = $(this).data('breakpoint-up') ?? 'xs';
  let breakpointDownVal = $(this).data('breakpoint-down') ?? 'xl';
  let loop = $(this).data('loop') ?? 'true';

  if (breakpointDown(breakpointDownVal) && breakpointUp(breakpointUpVal)) {
    let sliderC = $(this).closest('.part-phone-slider')
    let buttonNext = sliderC.find('.swiper-button-next')[0]
    let buttonPrev = sliderC.find('.swiper-button-prev')[0]
    let pagination = sliderC.find('.swiper-pagination')[0]

    let swiper = new Swiper(el, {
      modules: [Autoplay, Navigation, Pagination],
      loop: loop,
      navigation: {
        nextEl: buttonNext,
        prevEl: buttonPrev,
      },
      pagination: {
        el: pagination,
        type: "fraction",
      },
      slidesPerView: 2,
      spaceBetween: 12,
      on: {
        slideChange: function () {
          loadBlockLazyImages($(this.slides))
        }
      }
      // autoplay: {
      //   delay: 5000,
      // },
      //speed: 600,
    })

  }

})

